import { Unauthorized } from 'layouts/index'
import { useState, useRef } from 'react'
import { LoginContainer } from 'styles/index'
import { Form } from '@unform/web'
import { logo } from 'assets/Icons'
import { DefaultButton, Input, Loading, RecoverPass } from 'components/index'
import useFetch from 'hooks/useFetch'

export default function RecoveryPassword() {
  const [loading] = useState<boolean>(false)
  const [sent, setSent] = useState<boolean>(false)
  const [email, setEmail] = useState<string>('')
  // const [error, setError] = useState<any>()
  const [buttonLoading, setButtonLoading] = useState(false)

  const formRef = useRef<HTMLFormElement | any>(null)

  const api = useFetch('/gestor/recover')

  const handleSubmit = async () => {
    if (buttonLoading) return
    formRef?.current?.setErrors({})
    if (!email)
      return formRef?.current?.setErrors({ email: 'Campo obrigatório' })
    try {
      setButtonLoading(true)
      const r = await api.fetch('get', null, `/gestor/recover/${email}`)

      if (r.fail) {
        setButtonLoading(false)
        return formRef?.current?.setErrors({ password: r.errors.message })
      }

      setButtonLoading(false)
      setSent(true)
    } catch (err: any) {
      console.error(err)
      setButtonLoading(false)
      formRef?.current?.setErrors({ password: err.message })
    }
  }

  if (loading) return <Loading />

  return (
    <Unauthorized>
      <LoginContainer>
        <img className="login-company-logo" src={logo} alt="company Logo" />
        <span className="login-title">Esqueceu a senha?</span>
        <span className="recovery-subtitle">
          Digite seu email e enviaremos um link
          <b /> para redefinir sua senha
        </span>
        <Form
          onSubmit={() => console.log('submit')}
          className="login-form"
          autoComplete="off"
          ref={formRef}
        >
          <div className="input-container">
            <Input
              onChange={(e: any) => setEmail(e.target.value)}
              name="email"
              type="email"
              placeholder="Email"
              value={email}
              // error={error}
            />
          </div>
          <DefaultButton
            orange
            $loading={buttonLoading}
            disabled={sent}
            onClick={async () => handleSubmit()}
          >
            {sent ? 'Link enviado com sucesso!' : 'Redefinir senha'}
          </DefaultButton>

          <RecoverPass to="/login">Acessar conta!</RecoverPass>
        </Form>
      </LoginContainer>
    </Unauthorized>
  )
}
